import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {DoorType, getDoorTypeIcon, getDoorTypeLabel} from "../models/door";
import {catchError, from, lastValueFrom, map, Observable, of} from "rxjs";

@Component({
  selector: 'app-door-type-toggle',
  template: `
    <div class="select-sorting" style="margin-left: 0" *ngIf="dropdown">
      <select class="form-select w-auto flex-shrink-1" aria-label="select sorting"
              (change)="onChanged($any($event.target).value)">
        <option *ngFor="let doorTypeFilterOption of doorTypes" [value]="doorTypeFilterOption">
          {{ (getDoorTypeLabelOrTranslation(doorTypeFilterOption) | async) }}
        </option>
      </select>
    </div>

    <div *ngIf="!dropdown" class="btn-group generic-filter-door-type-group" role="group"
         aria-label="Basic radio toggle button group">
      <ng-container *ngFor="let doorTypeFilterOption of doorTypes">
        <input type="radio" class="btn-check" name="generic-filter-door-type"
               id="{{randomId}}-door-type-{{doorTypeFilterOption}}" autocomplete="off"
               [value]="doorTypeFilterOption"
               [(ngModel)]="currentSelectedDoorType"
               (ngModelChange)="onChanged($event)">
        <label class="btn btn-outline-primary" for="{{randomId}}-door-type-{{doorTypeFilterOption}}">
          <app-svg *ngIf="getDoorTypeIcon(doorTypeFilterOption)"
                   [src]="getDoorTypeIcon(doorTypeFilterOption)!"
                   style="height: 25px; display: inline-block"
                   [ngStyle]="doorTypeFilterOption === 'FLOOR' ? {'display': 'inline-block', 'width': '20px' } : {}">
          </app-svg>
          {{ (getDoorTypeLabelOrTranslation(doorTypeFilterOption) | async) }}
        </label>
      </ng-container>
    </div>
  `,
  styles: [`
  .generic-filter-door-type-group label {
    margin-left: 0 !important;
  }

  ::ng-deep {
    svg.icon {
      stroke: var(--customer-primary-color);
      fill: var(--customer-primary-color);
    }

    .generic-filter-door-type-group .btn-check:checked + .btn, .generic-filter-door-type-group .btn:hover {
      svg.icon {
        stroke: #FFFFFF;
        fill: #FFFFFF;
      }
    }
  }
  `]
})
export class DoorTypeToggle {
  private _defaultDoorType: DoorType = DoorType.SINGLE
  private _doorTypes: Array<DoorType> = []

  constructor(private translationService: TranslateService) {
  }

  public randomId = Math.random().toString(36).substring(7)

  // @ts-ignore
  public currentSelectedDoorType: DoorType = this._defaultDoorType

  @Output()
  public onValueChanged = new EventEmitter<DoorType>();

  public async onChanged(doorType: DoorType) {
    this.onValueChanged.emit(doorType)
  }

  @Input() dropdown?: boolean | null

  @Input() set defaultDoorType(defaultDoorType: DoorType) {
    this._defaultDoorType = defaultDoorType
  }

  @Input() set selected(currentSelectedDoorType: DoorType) {
    this.currentSelectedDoorType = currentSelectedDoorType
  }

  get defaultDoorType() {
    return this._defaultDoorType
  }

  @Input() set doorTypes(doorTypes: Array<DoorType>) {
    this._doorTypes = doorTypes
  }

  get doorTypes() {
    return this._doorTypes
  }

  public getDoorTypeIcon(doorType: DoorType): string | undefined {
    return getDoorTypeIcon(doorType)
  }

  public getDoorTypeLabelOrTranslation(doorType: DoorType): Observable<string> {
    return from(
      this.translationService.get(`doorType.${doorType}`)
    ).pipe(
      map((translation: string) => {
        if (translation && translation !== `doorType.${doorType}`) {
          return translation;
        }

        return getDoorTypeLabel(doorType)
      }),
      catchError(() => of(getDoorTypeLabel(doorType)))
    );
  }
}

